/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_Empty_State_TitleInputs */

const fr_payments_empty_state_title = /** @type {(inputs: Payments_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez encore aucun paiement.`)
};

/**

* @param {Payments_Empty_State_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_empty_state_title = /** @type {((inputs?: Payments_Empty_State_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_Empty_State_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_empty_state_title(inputs)
});